import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Wrapper = styled.div`
  text-align: center;
  padding: 64px 24px;

  ${media.mobile} {
    padding: 40px 16px;
  }
`;

export const IconWrapper = styled.div`
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors['neutral-40']};
  font-size: 48px;
  display: flex;
  justify-content: center;
`;

export const Title = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors['neutral-90']};
  margin: 0;
`;

export const Description = styled.p<{ $hasAction?: boolean }>`
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors['neutral-60']};
  max-width: 440px;
  margin: 8px auto ${({ $hasAction }) => ($hasAction ? '24px' : '0')};
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors['neutral-0']};
  background-color: ${({ theme }) => theme.colors['primary-60']};
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  -webkit-tap-highlight-color: transparent;

  &:hover {
    box-shadow: inset 999px 999px 0px rgba(255, 255, 255, 0.1);
  }

  ${media.mobile} {
    padding: 12px 24px;
    min-height: 44px;
  }
`;
